import { OrderedSet } from 'immutable';
import colorDataDefaults from 'ricos-schema/dist/statics/color.defaults.json';
import { Mark_Type } from 'ricos-types';
import { createRicosMarkExtension } from 'wix-rich-content-plugin-commons';
import { FOREGROUND_COLOR } from './dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const tiptapColorForegroundExtension = createRicosMarkExtension({
  type: "mark",
  name: Mark_Type.COLOR_FOREGROUND,
  groups: [],
  reconfigure: (config, _extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
    addOptions() {
      return __spreadValues({
        HTMLAttributes: {}
      }, settings);
    }
  }),
  createExtensionConfig() {
    return {
      name: this.name,
      addAttributes() {
        return {
          color: { default: colorDataDefaults.foreground }
        };
      },
      parseHTML() {
        return [
          {
            style: "color",
            getAttrs: (color) => ({ color })
          }
        ];
      },
      renderHTML({ HTMLAttributes: { color } }) {
        var _a, _b, _c, _d;
        const styleColor = ((_b = (_a = this.options).styleSelectionPredicate) == null ? void 0 : _b.call(_a, color)) ? (_d = (_c = this.options).customStyleFn) == null ? void 0 : _d.call(_c, OrderedSet([color])).color : color;
        return [
          "span",
          {
            "data-hook": FOREGROUND_COLOR,
            style: `color: ${styleColor}; text-decoration: inherit;`
          }
        ];
      },
      addCommands() {
        return {
          setColor: (color) => ({ commands }) => commands.setMark(this.name, { color }),
          unsetColor: () => ({ commands }) => commands.setMark(this.name, { color: null })
        };
      }
    };
  }
});

export { tiptapColorForegroundExtension };
//# sourceMappingURL=tiptap-foreground.js.map
